import { useEffect, useRef, useState } from "react";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const scrollToBooks = () => {
    const el = document.querySelector("#books");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative pt-20 md:pt-24 pb-12 md:pb-20 px-4 md:px-8 lg:px-12 bg-background-50 overflow-hidden">
      <div
        ref={ref}
        className={`w-full transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <img
              alt="Cappy and Barry Adventures"
              className="w-48 h-48 md:w-64 md:h-64 lg:w-72 lg:h-72 object-contain mx-auto lg:mx-0 mb-4"
              src="../../../../images/0ceb999f35a931c1da96a7ccbbd5c92f.png"
            />
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-semibold rounded-full mb-4">
              Ages 2&ndash;7
            </span>
            <h1 className="font-bold text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              Cappy and Barry Adventures
            </h1>
            <p className="text-lg md:text-xl text-foreground-600 mb-2 font-serif italic">
              Little stories. Big feelings. Gentle lessons.
            </p>
            <p className="text-base md:text-lg text-foreground-500 mb-6 leading-relaxed max-w-lg mx-auto lg:mx-0">
              Meet Cappy and Barry, two lovable capybaras who live on a sunny
              riverside. Cappy is small, cheeky, and full of energy. Barry is
              bigger, calmer, and very wise. Together they have adventures
              filled with laughter, learning, and life lessons that help little
              ones grow kind, brave, and thoughtful.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="https://cappybarry.gumroad.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-accent-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-accent-600 transition-colors text-center whitespace-nowrap"
              >
                Shop on Gumroad
                <i className="ri-external-link-line ml-2" />
              </a>
              <button
                onClick={scrollToBooks}
                className="border-2 border-foreground-200 text-foreground-800 px-6 py-3 rounded-full font-semibold hover:border-primary-500 hover:text-primary-500 transition-colors text-center whitespace-nowrap"
              >
                Meet the Books
                <i className="ri-arrow-down-line ml-2" />
              </button>
            </div>
          </div>

          <div className="flex-1 w-full relative">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 w-full animate-float shadow-2xl shadow-foreground-950/10">
              <img
                alt="Cappy and Barry on an adventure"
                className="w-full h-auto object-contain"
                src="../../../../images/68dd09e420da65915f378693f6488057.png"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}